import { jsxs as l, jsx as c } from "react/jsx-runtime";
const x = (o) => {
  const { icon: n, iconSize: e, iconLabelPosition: s, text: i } = o, t = {
    width: `${e}px`,
    height: `${e}px`,
    fontSize: `${e}px`,
    lineHeight: `${e}px`
  };
  return /* @__PURE__ */ l("span", { className: `checkbox-icon label-${s}`, children: [
    /* @__PURE__ */ c("span", { className: `rioglyph ${n}`, style: t }),
    /* @__PURE__ */ c("span", { className: "checkbox-label", children: i })
  ] });
};
export {
  x as CheckboxIcon
};
//# sourceMappingURL=CheckboxIcon.js.map
